export const uniqueArray = (list: any[]) => [...new Set(list)];
